import React from 'react';
import { TIME_RANGE_OPTIONS } from '../utils/timeRange';
import './TimeRangeSelector.css';

const TimeRangeSelector = ({ value = 'month', onChange, label = 'Time range', className = '' }) => (
  <div className={`time-range-selector ${className}`}>
    {label && <span className="time-range-label">{label}</span>}
    <select
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      className="time-range-select"
      aria-label={label}
    >
      {TIME_RANGE_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default TimeRangeSelector;
